import { createEntityAdapter } from '@reduxjs/toolkit';

const externalZonePlacementsAdapter = createEntityAdapter();

export default externalZonePlacementsAdapter;
